// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"488":"16983ec0","558":"eb93d456"}[chunkId] + ".chunk.js";
};